import { ILiveFrame } from 'types/detailsEntityType';
import { EntityType } from 'types/entityType';
import { LiveStatus } from 'utils/statuses';

export const initialFrameDetailsState: ILiveFrame = {
  spaceId: '0',
  name: '',
  mediaOwnerName: '',
  environment: '',
  formatSize: null,
  internetAccessAvailable: false,
  averageWeeklyImpactsAvailable: 0,
  planningRateCpm: '',
  currency: '',
  audienceDataSource: '',
  venueType: null,
  auctionToSpotTimeMinutes: 0,
  allowedMimeTypes: '',
  operatingHours: null,
  tags: [],
  latitude: 0,
  longitude: 0,
  zip: '',
  nativeResolution: '',
  consolidatedResolutions: [''],
  width: 0,
  height: 0,
  entityType: EntityType.FRAME,
  status: LiveStatus.ACTIVE,
  broadsignFrames: [],
  hasDraft: false,
};
